export class GenericAPIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GenericAPIError';
  }
}
